 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"05d954cf","1":"1bfc9850","2":"252f366e","3":"5e2a4920","4":"95b64a6e","5":"commons","6":"styles","7":"3da9cd2b844e721bde67d1c8589c1c953e9c80ec","8":"2944d2e88cebf0b3dd159a7d1445b8b10bcaf512","9":"b98bc7c3","10":"b0351553f058f0a337d4baebe1af0b343492a666","11":"component---src-pages-index-js","12":"cfbe5ff2ace0699def0b0820e3cb8c6b54b4f683","13":"8cf64b222becc07eb39f903f36e008675de23681","14":"ecde92643bf7779cdd03183fa5169c45d6feeeca","15":"05c08580545e3262a52c49575acca3e2e3ae1c45","17":"40465694","19":"component---src-pages-404-js","20":"component---src-pages-about-js","21":"component---src-pages-archive-js","22":"component---src-pages-articles-js","23":"component---src-pages-newsletter-js","24":"component---src-pages-tools-15-vs-30-year-mortgage-calculator-js","25":"component---src-pages-tools-algorand-staking-calculator-js","26":"component---src-pages-tools-avalanche-staking-calculator-js","27":"component---src-pages-tools-barista-fire-calc-js","28":"component---src-pages-tools-cardano-staking-calculator-js","29":"component---src-pages-tools-coast-fire-calc-js","30":"component---src-pages-tools-coast-fire-jobs-database-js","31":"component---src-pages-tools-coinbase-usdc-calculator-js","32":"component---src-pages-tools-compound-interest-calculator-js","33":"component---src-pages-tools-cosmos-staking-calculator-js","34":"component---src-pages-tools-electric-car-savings-calc-js","35":"component---src-pages-tools-emergency-fund-calculator-js","36":"component---src-pages-tools-ethereum-staking-calculator-js","37":"component---src-pages-tools-fat-fire-calculator-js","38":"component---src-pages-tools-fire-calculator-js","39":"component---src-pages-tools-fire-purchase-impact-calculator-js","40":"component---src-pages-tools-fire-windfall-impact-calculator-js","41":"component---src-pages-tools-flow-staking-calculator-js","42":"component---src-pages-tools-gas-mileage-savings-calc-js","43":"component---src-pages-tools-house-hacking-calculator-js","44":"component---src-pages-tools-hybrid-vs-gas-savings-calculator-js","45":"component---src-pages-tools-js","46":"component---src-pages-tools-kava-staking-calculator-js","47":"component---src-pages-tools-keeping-up-with-inflation-calculator-js","48":"component---src-pages-tools-kraken-polkadot-js","49":"component---src-pages-tools-kusama-staking-calculator-js","50":"component---src-pages-tools-loan-calculator-js","51":"component---src-pages-tools-portfolio-rebalancing-calc-js","52":"component---src-pages-tools-rental-property-calculator-js","53":"component---src-pages-tools-savings-rate-calculator-js","54":"component---src-pages-tools-solana-staking-calculator-js","55":"component---src-pages-tools-tezos-staking-calculator-js","56":"component---src-pages-tools-upwork-fee-calculator-js","57":"component---src-pages-tools-usdc-calculator-js","58":"component---src-templates-blog-post-js"}[chunkId]||chunkId) + "-" + {"0":"6e5c2e893daa941f5415","1":"937326993603d7043d81","2":"9a2b4dfb82a7fc1471c4","3":"31149ae7b8ef3ceb923c","4":"461b2db35463978247c3","5":"54bdd84e8cd6ba723d3c","6":"c4fa86dfd4ad05097eee","7":"c9675ed424ecf834b8f6","8":"fd1acff30400d5b5926c","9":"040456a8b37170b9e9ba","10":"1ad489f9682fac64a63a","11":"8d202763412924dd030b","12":"763511c3a3fd5a2ba3a1","13":"9f601f85ad2f35d135b8","14":"ee45a293eb7fe6045dad","15":"0edff719433d8e4904e5","17":"7bd5b04dd425f3cbbad9","19":"2723abe03b16f4a4602f","20":"290fdc0ec71994cf5275","21":"fdb58f01c65131cc82a7","22":"674702bbcff1978ae9b6","23":"d9f71d852acfe93c2f49","24":"32f216b4cb24d466ddc7","25":"b57c2398ac39f9507460","26":"8bf816742f4129db03d0","27":"85bb67fc19c0440a0c5a","28":"308a438eb5a7bdd87549","29":"f4a2a529fc88ad2411d3","30":"b55b4ad8614e000ba1ba","31":"a539e057db1dfed4353a","32":"c597785f4af9b0a12014","33":"c2a969e512ccee09eef6","34":"066657344398fad39001","35":"ec86d3925c7e2de97dcf","36":"5fe048e9ee1c5effb2ae","37":"a7898ddd07087e3de5cd","38":"3d15105a4bbce0c337d2","39":"a0c2ff6fb4a913d30863","40":"21aba7ee5afd964e9caf","41":"cf70b470aa2b9ea0cdf7","42":"197f9ce888a4a5f0c3c5","43":"ff6ecdb3dde0bc87a8ef","44":"ce5f414164e506263040","45":"5f62b5b4ab48292d6046","46":"60a7e1b8f622ec12ecea","47":"c1a9ffe92b708d02b58f","48":"2aa63a0ba2d06e4381da","49":"cad99992d0143a41479f","50":"aaad5056ee3d713b1728","51":"444ea9ba11238b6dee14","52":"3ea24709a570dcb89750","53":"f203a535fe47cccbdfc4","54":"8b5d3a3bc3974e918a52","55":"c5819813682ce001068c","56":"191818c61dbf1bab902d","57":"4d5b983135f825ae4176","58":"a66d01df89f98513c5c6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"05d954cf","1":"1bfc9850","2":"252f366e","3":"5e2a4920","4":"95b64a6e","5":"commons","6":"styles","7":"3da9cd2b844e721bde67d1c8589c1c953e9c80ec","8":"2944d2e88cebf0b3dd159a7d1445b8b10bcaf512","9":"b98bc7c3","10":"b0351553f058f0a337d4baebe1af0b343492a666","11":"component---src-pages-index-js","12":"cfbe5ff2ace0699def0b0820e3cb8c6b54b4f683","13":"8cf64b222becc07eb39f903f36e008675de23681","14":"ecde92643bf7779cdd03183fa5169c45d6feeeca","15":"05c08580545e3262a52c49575acca3e2e3ae1c45","17":"40465694","19":"component---src-pages-404-js","20":"component---src-pages-about-js","21":"component---src-pages-archive-js","22":"component---src-pages-articles-js","23":"component---src-pages-newsletter-js","24":"component---src-pages-tools-15-vs-30-year-mortgage-calculator-js","25":"component---src-pages-tools-algorand-staking-calculator-js","26":"component---src-pages-tools-avalanche-staking-calculator-js","27":"component---src-pages-tools-barista-fire-calc-js","28":"component---src-pages-tools-cardano-staking-calculator-js","29":"component---src-pages-tools-coast-fire-calc-js","30":"component---src-pages-tools-coast-fire-jobs-database-js","31":"component---src-pages-tools-coinbase-usdc-calculator-js","32":"component---src-pages-tools-compound-interest-calculator-js","33":"component---src-pages-tools-cosmos-staking-calculator-js","34":"component---src-pages-tools-electric-car-savings-calc-js","35":"component---src-pages-tools-emergency-fund-calculator-js","36":"component---src-pages-tools-ethereum-staking-calculator-js","37":"component---src-pages-tools-fat-fire-calculator-js","38":"component---src-pages-tools-fire-calculator-js","39":"component---src-pages-tools-fire-purchase-impact-calculator-js","40":"component---src-pages-tools-fire-windfall-impact-calculator-js","41":"component---src-pages-tools-flow-staking-calculator-js","42":"component---src-pages-tools-gas-mileage-savings-calc-js","43":"component---src-pages-tools-house-hacking-calculator-js","44":"component---src-pages-tools-hybrid-vs-gas-savings-calculator-js","45":"component---src-pages-tools-js","46":"component---src-pages-tools-kava-staking-calculator-js","47":"component---src-pages-tools-keeping-up-with-inflation-calculator-js","48":"component---src-pages-tools-kraken-polkadot-js","49":"component---src-pages-tools-kusama-staking-calculator-js","50":"component---src-pages-tools-loan-calculator-js","51":"component---src-pages-tools-portfolio-rebalancing-calc-js","52":"component---src-pages-tools-rental-property-calculator-js","53":"component---src-pages-tools-savings-rate-calculator-js","54":"component---src-pages-tools-solana-staking-calculator-js","55":"component---src-pages-tools-tezos-staking-calculator-js","56":"component---src-pages-tools-upwork-fee-calculator-js","57":"component---src-pages-tools-usdc-calculator-js","58":"component---src-templates-blog-post-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"efea52f2ee21da669bc6","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
